import React, { useState, useEffect, useRef } from 'react';
import Timer from './components/Timer';
import './styles/App.css';

const DURATIONS = {
    pomodoro: 25 * 60,
    short: 5 * 60,
    long: 15 * 60,
    test: 5, // 5 seconds for quick testing
};

const CELEBRATION_DURATION = 3000; // 3 seconds

const App = () => {
    const [mode, setMode] = useState('pomodoro');
    const [timeLeft, setTimeLeft] = useState(DURATIONS.pomodoro);
    const [isActive, setIsActive] = useState(false);
    const [showCelebration, setShowCelebration] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        setTimeLeft(DURATIONS[mode]);
        setIsActive(false);
        setShowCelebration(false);
    }, [mode]);

    useEffect(() => {
        if (isActive && timeLeft > 0) {
            intervalRef.current = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
        } else if (!isActive) {
            clearInterval(intervalRef.current);
        }
        if (timeLeft === 0 && isActive) {
            clearInterval(intervalRef.current);
            setIsActive(false);
            setShowCelebration(true);
            setTimeout(() => setShowCelebration(false), CELEBRATION_DURATION);
        }
        return () => clearInterval(intervalRef.current);
    }, [isActive, timeLeft]);

    const startTimer = () => setIsActive(true);
    const pauseTimer = () => setIsActive(false);
    const resetTimer = () => {
        setIsActive(false);
        setTimeLeft(DURATIONS[mode]);
        setShowCelebration(false);
    };

    return (
        <div className="container">
            <h1>Pomodoro Timer</h1>
            <div className="controls" style={{ marginBottom: 20 }}>
                <button className="button" onClick={() => setMode('pomodoro')} disabled={mode==='pomodoro'}>Pomodoro</button>
                <button className="button" onClick={() => setMode('short')} disabled={mode==='short'}>Short Break</button>
                <button className="button" onClick={() => setMode('long')} disabled={mode==='long'}>Long Break</button>
                <button className="button" onClick={() => setMode('test')} disabled={mode==='test'}>Test (5s)</button>
            </div>
            <Timer timeLeft={timeLeft} />
            <div className="controls">
                <button className="button" onClick={startTimer} disabled={isActive || timeLeft === 0}>Start</button>
                <button className="button" onClick={pauseTimer} disabled={!isActive}>Pause</button>
                <button className="button" onClick={resetTimer}>Reset</button>
            </div>
            {showCelebration && (
                <div className="celebration">
                    <span role="img" aria-label="party popper" style={{fontSize: '3rem'}}>🎉</span>
                    <h2>Great job! Time's up!</h2>
                </div>
            )}
        </div>
    );
};

export default App;